var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidanceUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.25C20 7.1775 20.9162 8.5625 21.8437 9.725C23.0362 11.225 24.4612 12.5338 26.095 13.5325C27.32 14.2813 28.805 15 30 15M30 15C28.805 15 27.3187 15.7187 26.095 16.4675C24.4612 17.4675 23.0362 18.7762 21.8437 20.2737C20.9162 21.4375 20 22.825 20 23.75M30 15L0 15",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidanceUpArrow);
export default __webpack_public_path__ + "static/media/guidance_up-arrow.895bf107863353efc880848f032b4e71.svg";
export { ForwardRef as ReactComponent };